import httpClient from './httpClient'
import { bffURL } from '../config'

export default class AdditionalSteps {
  static async getWotcWithToken (postingId, token, idToken) {
    return await httpClient.get(`${bffURL}/postings/wotc/postings/${postingId}/token/${token}/initiate-screening?channel=trapply`, idToken)
  }
}
